module.exports = __webpack_public_path__ + "static/media/Blue1.1b71f0d3.png";